import { render, staticRenderFns } from "./PrefixIconColumn.vue?vue&type=template&id=62ad484e&scoped=true"
import script from "./PrefixIconColumn.vue?vue&type=script&lang=js"
export * from "./PrefixIconColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad484e",
  null
  
)

export default component.exports